// extracted by mini-css-extract-plugin
module.exports = {"container":"EB-T18P-1MT4bVp3Lr5Q8"};